import {html} from 'lit';
import {
	selectSolarActivityLevelIsSatisfied,
	selectSolarActivityLevel,
	selectSolarLocationIsSatisfied,
	selectSolarLocation,
	selectSolarDimmProfile,
	selectSolarDimmProfileIsSatisfied,
	selectSolarShadowLevel,
	selectSolarShadowLevelIsSatisfied,
	selectSolarAzimuth,
	selectSolarAzimuthIsSatisfied, selectSolarUnitHeight, selectSolarUnitHeightIsSatisfied, selectSolarVersion,
} from './solarSelectors';

import {fetchSolarGeolocation, fetchSolarLocation} from './solarSlice';
import {solarDimmProfileOptions} from './dimProfiles';
import {isSatisfied} from '../util/values';
import {selectSpcIsSatisfied} from '../selectors';

export const solarActivityLevelOptions = [
	{
		id: 'none',
		factor: 0,
		label: {
			de: 'Kein Bewegungssensor',
			en: 'No motion sensor',
			fr: 'Pas de détecteur de mouvement',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'low',
		factor: 0.1,
		label: {
			de: 'Geringe Personenaktivität',
			en: 'Low pedestrian activity',
			fr: 'Faible activité piétonne',
		},
		description: {
			de: 'bis zu 6 Auslösungen pro Stunde',
			en: 'up to 6 triggers per hour',
			fr: 'jusqu\'à 6 déclenchements par heure',
		}
	},
	{
		id: 'medium',
		factor: 0.25,
		label: {
			de: 'Moderate Personenaktivität',
			en: 'Moderate pedestrian activity',
			fr: 'Activité piétonne modérée',
		},
		description: {
			de: 'bis zu 15 Auslösungen pro Stunde',
			en: 'up to 15 triggers per hour',
			fr: 'jusqu\'à 15 déclenchements par heure',
		}
	},
	{
		id: 'high',
		factor: 0.5,
		label: {
			de: 'Hohe Personenaktivität',
			en: 'High pedestrian activity',
			fr: 'Forte activité piétonne',
		},
		description: {
			de: 'bis zu 30 Auslösungen pro Stunde',
			en: 'up to 30 triggers per hour',
			fr: 'jusqu\'à 30 déclenchements par heure',
		}
	},
];
export const solarShadowLevelOptions = [
	{
		id: 'none',
		factor: 1,
		label: {
			de: 'Unverschattet',
			en: 'Unshaded',
			fr: 'Sans ombrage',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'level1',
		factor: 0.8,
		label: {
			de: 'Leicht verschattet',
			en: 'Lightly shaded',
			fr: 'Légèrement ombragé',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'level2',
		factor: 0.65,
		label: {
			de: 'Mittel verschattet',
			en: 'Moderately shaded',
			fr: 'Moyennement ombragé',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'level3',
		factor: 0.5,
		label: {
			de: 'Stark verschattet',
			en: 'Heavily shaded',
			fr: 'Fortement ombragé',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'level4',
		factor: 0.4,
		label: {
			de: 'Sehr stark verschattet',
			en: 'Very heavily shaded',
			fr: 'Très fortement ombragé',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
];
export const solarAzimuthOptions = [
	{
		id: 's',
		angle: 0,
		label: {
			de: 'S',
			en: 'S',
			fr: 'S',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'se',
		angle: -45,
		label: {
			de: 'SO',
			en: 'SE',
			fr: 'SE',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'e',
		angle: -90,
		label: {
			de: 'O',
			en: 'E',
			fr: 'E',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'ne',
		angle: -135,
		label: {
			de: 'NO',
			en: 'NE',
			fr: 'NE',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'n',
		angle: -180,
		label: {
			de: 'N',
			en: 'N',
			fr: 'N',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'nw',
		angle: 135,
		label: {
			de: 'NW',
			en: 'NW',
			fr: 'NO',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'w',
		angle: 90,
		label: {
			de: 'W',
			en: 'W',
			fr: 'O',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
	{
		id: 'sw',
		angle: 45,
		label: {
			de: 'SW',
			en: 'SW',
			fr: 'SO',
		},
		description: {
			de: '',
			en: '',
			fr: '',
		}
	},
];

export const solarBatteryTypeOptions = [
	{
		id: 'NiMH',
		label: {
			de: 'NiMH',
			en: 'NiMH',
			fr: 'NiMH',
		}
	},
	{
		id: 'SiB',
		label: {
			de: 'SiB',
			en: 'SiB',
			fr: 'SiB',
		}
	},
];
export const solarVersionOptions = [
	{
		id: 'basic',
		label: {
			de: 'Basic',
			en: 'Basic',
			fr: 'De base',
		}
	},
	{
		id: 'pro',
		label: {
			de: 'Pro',
			en: 'Pro',
			fr: 'Pro',
		}
	},
];

export const solarLumPositionOptions = [
	{
		id: '1',
		label: {
			de: '1 Meter',
			en: '1 Meter',
			fr: '1 Meter',
		}
	},
	{
		id: '2',
		label: {
			de: '2 Meter',
			en: '2 Meter',
			fr: '2 Meter',
		}
	},
	{
		id: '3',
		label: {
			de: '3 Meter',
			en: '3 Meter',
			fr: '3 Meter',
		}
	},
	{
		id: '4',
		label: {
			de: '4 Meter',
			en: '4 Meter',
			fr: '4 Meter',
		}
	},
];

export const solarSectionConfig = [
	{
		id: 'start',
		label: {
			de: 'Konfigurator',
			en: 'Configurator',
			fr: 'Configurator',
		},
		visual: 'solarStart',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`
				<solar-start></solar-start>`,
		]
	},
	{
		id: 'location',
		label: {
			de: 'Ort',
			en: 'Location',
			fr: 'Localisation',
		},
		visual: 'solarLocation',
		features: [],
		isSatisfied: selectSolarLocationIsSatisfied,
		widgets: [
			html`
				<assistant-wrapper .title=${{
					de: 'Wo befindet sich Ihr Projekt, das beleuchtet werden soll?',
					en: 'Where is your project located?',
					fr: 'Où se situe votre projet ?',
				}}>
					<location-select
						.action=${fetchSolarLocation}
						.geolocateAction=${fetchSolarGeolocation}
						.selectedLocation=${selectSolarLocation}
						.isSatisfied=${selectSolarLocationIsSatisfied}></location-select>
				</assistant-wrapper>`,
			html`
				<assistant-wrapper .loginRequired=${true} .smallTitle=${true} .title=${{
					de: 'Angaben zur Sonneneinstrahlung',
					en: 'Information on solar radiation',
					fr: 'Informations sur le rayonnement solaire',
				}}>
					<list-select
						.title=${{
							de: 'Verschattung',
							en: 'Shading',
							fr: 'Ombrage'
						}}
						.options=${solarShadowLevelOptions}
						action='solar/setSolarShadowLevel'
						.selected=${selectSolarShadowLevel}
						.canBeSelected=${() => true}
						.isSatisfied=${selectSolarShadowLevelIsSatisfied}>
					</list-select>
					<list-select
						.title=${{
							de: 'Ausrichtung des Leuchtenkopfs',
							en: 'Orientation of luminaire head',
							fr: 'Orientation du luminaire'
						}}
						.options=${solarAzimuthOptions}
						action='solar/setSolarAzimuth'
						.selected=${selectSolarAzimuth}
						.canBeSelected=${() => true}
						.isSatisfied=${selectSolarAzimuthIsSatisfied}></list-select>
				</assistant-wrapper>`
		]
	},
	{
		id: 'dimmprofile',
		label: {
			de: 'Beleuchtungsprofil',
			en: 'Lighting profile',
			fr: 'Profil lumineux',
		},
		visual: 'solarProfile',
		features: [],
		isSatisfied: selectSolarDimmProfileIsSatisfied,
		widgets: [
			html`
				<assistant-list-select
					.title=${{
						de: 'Wie soll Ihr Projekt beleuchtet werden?',
						en: 'How should your project be illuminated?',
						fr: 'Comment votre projet doit-il être éclairé ?'
					}}
					.options=${solarDimmProfileOptions}
					action='solar/setSolarDimmProfile'
					.selected=${selectSolarDimmProfile}
					.canBeSelected=${() => true}
					.isSatisfied=${selectSolarDimmProfileIsSatisfied}></assistant-list-select>`,
		]
	},
	{
		id: 'temperature',
		label: {
			de: 'Lichtfarbe',
			en: 'Light colour',
			fr: 'Couleur de la lumière',
		},
		visual: 'solarLightTemperature',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`
				<spc-assistant-choice-attribute
					.title=${{
						de: 'Welche Lichtfarbe soll eingesetzt werden?',
						en: 'What light colour should be used?',
						fr: 'Quelle température de couleur utiliser ?'
					}}
					.attributeId=${{localId: 'LE_ColourTemperature_1'}}
					.hideDisabled=${true}>
				</spc-assistant-choice-attribute>`,
		]
	},
	{
		id: 'activityLevel',
		label: {
			de: 'Bewegungssensor',
			en: 'Motion Sensor',
			fr: 'Détecteur de mouvement',
		},
		visual: 'solarActivityLevel',
		features: [],
		isSatisfied: selectSolarActivityLevelIsSatisfied,
		widgets: [
			html`
				<assistant-list-select
					.title=${{
						de: 'Soll ein Bewegungssensor eingesetzt werden? Falls ja, wie ist die Personenaktivität an diesem Standort?',
						en: 'Should a motion sensor be deployed? If so, what is the level of pedestrian activity at this location?',
						fr: 'Faut-il installer un détecteur de mouvement ? Si oui, quel est le niveau d\'activité des piétons à cet endroit ?'
					}}
					.options=${solarActivityLevelOptions}
					action='solar/setSolarActivityLevel'
					.selected=${selectSolarActivityLevel}
					.canBeSelected=${(state, id) => (['profile3', 'profile4', 'profile5'].includes(selectSolarDimmProfile(state)) ? id === 'none' : true)}
					.isSatisfied=${selectSolarActivityLevelIsSatisfied}></assistant-list-select>`,
		]
	},
	{
		id: 'recommendation',
		label: {
			de: 'Energieertrag und Lichtleistung',
			en: 'Energy yield and light output',
			fr: 'Rendement énergétique et puissance lumineuse',
		},
		visual: 'solarRecommendations',
		features: [],
		isSatisfied: selectSolarUnitHeightIsSatisfied,
		widgets: null
	},
	{
		id: 'luminar',
		label: {
			de: 'Licht und Gehäuse',
			en: 'Luminaire and Housing',
			fr: 'Luminaire et mât',
		},
		visual: 'solarLuminar',
		features: [
			// 'root::CX_Region',
			// 'root::EB_Control_1',
			// 'root::EB_ControlNoWire_1',
			// 'root::EB_ControlWire_1',
			// 'root::EB_ElectricalProtectionClass_1',
			// 'root::EB_MotionSensor_1',
			// 'root::EB_Wattage_1',
			// 'root::EB_Zhaga_1',
			// 'root::HS_Base',
			// 'root::HS_CircularBaseProfile',
			// 'root::HS_ColourPriceCategory',
			// 'root::HS_Construction',
			// 'root::HS_HousingCoating',
			// 'root::HS_HousingColour',
			// 'root::HS_HousingHeight',
			// 'root::HS_HousingMountingLocationBattery',
			// 'root::HS_HousingMountingLocationEblock',
			// 'root::HS_HousingShape',
			// 'root::HS_HousingSize',
			// 'root::HS_HousingType',
			// 'root::HS_HousingZhaga',
			// 'root::HS_LightEmission',
			'root::HS_LightEmissionCA',
			// 'root::HS_NumberPoleDoors',
			'root::HS_UpLight',
			// 'root::LE_ColourTemperature_1',
			// 'root::LE_ColourTemperature_2',
			// 'root::LE_DimmingLevel_1',
			// 'root::LE_DimmingLevel_2',
			// 'root::LE_LightDistribution_1',
			// 'root::LE_LightDistribution_2',
			// 'root::LE_LuminairePositionAngle_1',
			// 'root::LE_LuminairePositionAngle_2',
			// 'root::LE_LuminairePositionHeight_1',
			// 'root::LE_LuminairePositionHeight_2',
			// 'root::LE_LuminairePositionHeightSU_1',
			// 'root::LE_LuminairePositionHeightSU_2',
			// 'root::LE_LuminousFlux_1',
			// 'root::LE_LuminousFlux_2',
			// 'root::LU_Battery',
			// 'root::LU_Battery_LegacyArticleNumberGerman',
			// 'root::LU_Housing_LegacyArticleNumberGerman',
			// 'root::LU_LegacyArticleNumberGerman_1',
			// 'root::LU_LegacyArticleNumberGerman_2',
			// 'root::LU_SolarUnit',
			// 'root::LU_SolarUnit_LegacyArticleNumberGerman',
			// 'root::LU_SolarUnitHeight',
		],
		isSatisfied: selectSpcIsSatisfied,
		widgets: [html`
			<solar-layout-settings></solar-layout-settings>`]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

